import axios from 'axios';

export function getDeliverymen() {
    return new Promise((resolve, reject) => {
        axios.get('/web/deliverymen')
            .then(response => {
                const deliverymen = [];
                response.data.forEach(deliveryman => {
                    deliveryman.orders.forEach(ticket => {
                        if(ticket.current_status == "pending") {
                            ticket.status = "Por asignar"; ticket.statusId = 0;
                            ticket.dropdownMenu = "pendingDropdown";
                            ticket.deliveryman_name = "-";
                        }
                        else if( ticket.current_status == "assigned" ) {
                            ticket.status = "Asignado"; ticket.statusId = 1;
                            ticket.dropdownMenu = "assignedDropdown";
                        }
                        else if( ticket.current_status == "collecting" ) {
                            ticket.status = "Recolectando"; ticket.statusId = 2;
                            ticket.dropdownMenu = "collectingDropdown";
                        }
                        else if( ticket.current_status == "collected") {
                            ticket.status = "En camino"; ticket.statusId = 3;
                            ticket.dropdownMenu = "collectedDropdown";
                        }
                        else if(ticket.current_status == "delivered") {
                            ticket.status = "Entregado"; ticket.statusId = 5;    
                            ticket.dropdownMenu = "deliveredDropdown";     
                        } else {
                            ticket.status = "Cancelado"; ticket.statusId = -1;
                            if(!ticket.deliveryman_name) {
                                ticket.deliveryman_name = "-";
                            }
                        }
                        //Ticket currency formats
                        ticket.subtotal = ticket.subtotal?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});
                        ticket.tax = ticket.tax?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});
                        ticket.total = ticket.total?.toLocaleString("es-MX", {style: "currency", currency: "MXN"});

                        //Ticket date format to get just the date
                        var date = ticket.created_at.split("T");
                        ticket.created_at = date[0];
                    });

                    deliverymen.push(deliveryman);
                })
                resolve(deliverymen);
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function assignDeliveryman(ticket_number, deliveryman_uuid) {
    return new Promise((resolve, reject) => {
        axios.post('/web/orders/' + ticket_number + '/assign', {
            deliveryman_uuid: deliveryman_uuid
            })
            .then(response => {
                const assignedResponse = {
                    "deliveryman_name" : null,
                    "message" : "",
                    "status" : null
                };

                assignedResponse.status = response.data.status;
                assignedResponse.message = response.data.message;

                if(response.data.status == "success") {
                   assignedResponse.deliveryman_name = response.data.deliveryman_name;      
                }

                resolve(assignedResponse);
                
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function getDeliverymenLocation(deliverymen_uuid) {
    return new Promise((resolve, reject) => {
        axios.post('/web/deliverymen/location', {"delivery" : deliverymen_uuid})
            .then(response => {
                const location= {
                    "deliveryman_uuid" : response.data.deliveryman_uuid,
                    "location": {
                        "latitude": response.data.location.latitude,
                        "longitude": response.data.location.longitude
                    },
                    "created_at" : response.data.created_at,
                };
                resolve(location);
            })
            .catch(error => {
                reject(error);
            });
    })
}

export default {
    getDeliverymen,
    assignDeliveryman,
    getDeliverymenLocation
}